import { cyan } from '@/theme/colors'

export default {
  defaultFillColor: '#ff842611',
  defaultStrokeColor: '#ff842688',
  defaultEdgeColor: '#ff8426FF',
  selectedFillColor: '#00FF0011',
  selectedStrokeColor: '#00FF0088',
  selectedEdgeColor: '#00FF00FF',
  defaultGripFillColor: '#FFFFFF',
  defaultGripStrokeColor: '#1AADFB',
  defaultGripStokeWidth: 1,
  baseLabelFillColor: '#37CCBE11',
  baseLabelStrokeColor: '#37CCBE88',
  unselectedLabelFillColor: '#8F87AA11',
  unselectedLabelStrokeColor: '#8F87AA88',
  selectedLabelFillColor: '#200F5611',
  selectedLabelStrokeColor: '#200F5688',
  selectedLabelFillColorLight: '#ff842611',
  selectedLabelStrokeColorLight: '#ff842688',
  noClassificationFillColor: '#99999922',
  noClassificationStrokeColor: '#99999988',
  strokeWidth: 2,
  edgeRadius: 8,
  selectedElementColor: 'rgb(99, 102, 241)',
  selectedElementColor10: 'rgb(99, 102, 241, 0.05)',
  unselectedElementColor: 'rgb(21, 183, 158)',
  unselectedElementColor10: 'rgb(21, 183, 158, 0.05)',
  /** Grille articles (tracé + bbox figée) — aligné sur primary.main. */
  articleGridDrawingColor: cyan.main,
  articleGridDrawingColor10: cyan.alpha8!,
  /** Colonne articles dans une grille existante (tracé + bbox figée). */
  articleColumnDrawingColor: 'rgb(99, 102, 241)',
  articleColumnDrawingColor10: 'rgba(99, 102, 241, 0.08)',
  /** Champ document (tracé + bbox figée non classifiée). */
  fieldDrawingFill: '#f5a14211',
  fieldDrawingStroke: '#f5a14288',
  unclassifiedElementColor: '#9DA0A6',
  gridEditRectStroke: '#06AED4',
  gridEditDelimiter: '#F79009',
}
